import React, { FC, useCallback } from 'react';

// routing related
import useCustomRouter from '@hooks/useCustomRouter';
import routes from '../../constants/routes';

// component related
import HomePageOptionsCard from './HomePageOptionsCard/index';
import { HomePageOptionsProps } from '.';
import useTranslations from '@hooks/useTranslations';
import { BRAND } from '../../constants/main';
import { useSelector } from 'react-redux';
import { buildParameterizedPathname } from '@utils/url.utils';
import FilterDuck from '../../redux/filters/filter.duck';
import { CarJourneyType } from '../../services';
import { getAssetUrl } from '@utils/assetUrl.utils';

export const HomePageOptionsTemplate: FC<HomePageOptionsProps> = ({
    isConfigurableAvailable,
    isStockAvailable,
    className,
}): JSX.Element => {
    const router = useCustomRouter();
    const { t } = useTranslations();

    const paymentJourney = useSelector((state) => FilterDuck.getPaymentJourneyType(state));
    const handleStockJourneyClick = useCallback(() => {
        router.push(buildParameterizedPathname(routes.ROOT, CarJourneyType.STOCK));
    }, [paymentJourney]);

    const handleConfigurableJourneyClick = useCallback(() => {
        router.push(buildParameterizedPathname(routes.ROOT, CarJourneyType.CONFIGURABLE));
    }, [paymentJourney]);

    return (
        <div className={className} data-testid="TESTING_HOMEPAGE_OPTIONS">
            <div className="homepage-headline">
                <div className="container">
                    <h1 className="homepage-headline--main">{t('landingPage.mainTitle')}</h1>
                    <h2 className="homepage-headline--sub">{t('landingPage.subTitle')}</h2>
                </div>
            </div>
            <div className="homepage-optionCard--wrapper">
                {isConfigurableAvailable && (
                    <HomePageOptionsCard
                        className="offer-card"
                        imageUrl={getAssetUrl(`/images/offer.${BRAND}.png`)}
                        routeTitle={t('landingPage.offerCard.title')}
                        buttonText={t('landingPage.offerCard.button')}
                        onRedirect={handleConfigurableJourneyClick}
                    />
                )}

                {isStockAvailable && (
                    <HomePageOptionsCard
                        className="stock-card"
                        imageUrl={getAssetUrl(`/images/stock.${BRAND}.png`)}
                        routeTitle={t('landingPage.stockCard.title')}
                        buttonText={t('landingPage.stockCard.button')}
                        onRedirect={handleStockJourneyClick}
                    />
                )}
            </div>
        </div>
    );
};
